import React, { useEffect, useRef } from "react";
import { ImgUrlToBase64Props } from "./types";

const fetchImageAsBase64 = async (url: string): Promise<string | undefined> => {
  const response = await fetch(url);
  const blob = await response.blob();

  const mimeType = blob.type || "image/png";

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result
        ?.toString()
        .replace(/^data:application\/octet-stream/, `data:${mimeType}`);
      resolve(base64String);
    };
    reader.onerror = () =>
      reject(new Error("Failed to convert image to base64."));
    reader.readAsDataURL(blob);
  });
};

export const ImgUrlToBase64: React.FC<ImgUrlToBase64Props> = ({
  src,
  style,
  width,
  height,
}) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const fetchAndConvertImage = async (src: string) => {
      try {
        const base64 = await fetchImageAsBase64(src);

        if (imgRef.current && imgRef.current.children.length === 0 && base64) {
          const img = document.createElement("img");
          (img.style as any).width = width + "px";
          (img.style as any).height = height + "px";
          img.src = base64;
          imgRef.current.appendChild(img);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (src) {
      fetchAndConvertImage(src); // Fetch image on mount or imageUrl change
    }
  }, [height, src, width]);

  return <div style={style} ref={imgRef}></div>;
};
